import Image from 'next/image';
import ReactMarkdown from 'react-markdown';
import { SellingPointsStyle } from '../../styles/components/country';

export interface ISellingPoints {
  title: string;
  description: string;
  sellingPointsItems: {
    title: string;
    description: string;
    iconPath: string;
  }[];
}

const SellingPoints = (props: ISellingPoints) => {
  return (
    <div className={SellingPointsStyle['selling-points']}>
      <div className={SellingPointsStyle['selling-points-items-heading']}>
        <h2>{props.title}</h2>
        <ReactMarkdown>{props.description}</ReactMarkdown>
      </div>
      <div className={SellingPointsStyle['selling-points-items']}>
        {props.sellingPointsItems.map((sellingPoint, index) => {
          return (
            <div className={SellingPointsStyle['item']} key={index}>
              <Image
                quality={90}
                className={SellingPointsStyle.icon}
                src={sellingPoint.iconPath}
                alt={sellingPoint.title}
                width={90}
                height={120}
              />
              <div className={SellingPointsStyle['type']}>
                <span className={SellingPointsStyle['name']}>
                  {sellingPoint.title}
                </span>
                <ReactMarkdown>{sellingPoint.description}</ReactMarkdown>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SellingPoints;
